import { logger, prepareAndMakeRequest } from '../requestService';

export const createUser = async (
  tenantId: string,
  userId: string,
  displayName: string,
  emailAddress: string,
  timezone: string
) => {
  try {
    const user = {
      displayName: displayName,
      email: emailAddress,
      timezone: timezone,
    };

    return await prepareAndMakeRequest({
      path: `/workplace-integration/Customers/${tenantId}/users`,
      method: 'PUT',
      memberId: userId,
      record: user,
    });
  } catch (error: any) {
    logger.error('Feature -> Tab -> API', 'createUser', error.message, error);
  }
};

export const getUser = async (userId: string) => {
  try {
    return await prepareAndMakeRequest({
      path: `/workplace-integration/Users/${userId}`,
      method: 'GET',
      memberId: userId,
    });
  } catch (error: any) {
    logger.error('Feature -> Tab -> API', 'getUser', error.message, error);
  }
};

export const getUserRoles = async (userId: string) => {
  try {
    return await prepareAndMakeRequest({
      path: `/workplace-integration/users/${userId}/roles`,
      method: 'GET',
      memberId: userId,
    });
  } catch (error: any) {
    logger.error('Feature -> Tab -> API', 'getUser', error.message, error);
  }
};

export const getGroovIndexes = async (userId: string, period: string) => {
  try {
    return await prepareAndMakeRequest({
      path: `/workplace-integration/v2/groov-index?user_id=${userId}&period=${period}`,
      method: 'GET',
      memberId: userId,
    });
  } catch (error: any) {
    logger.error('Feature -> Tab -> API', 'getGroovIndexes', error.message, error);
  }
};

export const getOrgConfigByIntegrationId = async (
  integrationId: string
): Promise<any> => {
  try {
    logger.info(
      'Feature -> Tab -> API',
      `Fetching org configuration for integration: ${integrationId}`
    );
    return await prepareAndMakeRequest({
      path: `/workplace-integration/v3/orgs/integration/${integrationId}/platform/msteams/configuration`,
      method: 'GET',
      tokenType: 'ADMIN_TOKEN',
    });
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    logger.error(
      'Feature -> Tab -> API',
      'getOrgConfigByIntegrationId',
      `Error fetching org configuration for ${integrationId}: ${errorMessage}`,
      error
    );
    throw error;
  }
};

export const getUserConfigByUserId = async (
  userId: string
): Promise<any> => {
  try {
    logger.info(
      'Feature -> Tab -> API',
      `Fetching user configuration for user: ${userId}`
    );
    return await prepareAndMakeRequest({
      path: `/workplace-integration/v3/users/${userId}/config?platform=msteams`,
      method: 'GET',
      memberId: userId,
    });
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    logger.error(
      'Feature -> Tab -> API',
      'getUserConfigByUserId',
      `Error fetching user configuration for ${userId}: ${errorMessage}`,
      error
    );
    throw error;
  }
};
